import React, { useState, useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import { Toaster, toast } from 'sonner';
import { CommandPalette, useCommandPalette } from '../components/MockUI';
import api from '../services/api';

export default function DashboardLayout() {
  const [collapsed, setCollapsed] = useState(() => localStorage.getItem('sb_collapsed') === '1');
  const [cmdOpen, setCmdOpen] = useState(false);
  const navigate = useNavigate();
  useCommandPalette(setCmdOpen);

  useEffect(() => {
    const checkAlerts = async () => {
      if (sessionStorage.getItem('fleet_alerts_shown') === '1') return;
      try {
        const { data } = await api.get('/fleet-dashboard/alerts');
        if (data && data.length > 0) {
          const vencidos = data.filter(a => a.days < 0).length;
          const vencendo = data.length - vencidos;
          let msg = `Você possui ${data.length} alertas de frota. `;
          if (vencidos > 0) msg += `${vencidos} vencidos. `;
          if (vencendo > 0) msg += `${vencendo} a vencer em 90 dias.`;
          
          toast.warning('Alertas de Frota', {
            description: msg,
            duration: 10000,
            action: {
              label: 'Ver frota',
              onClick: () => navigate('/frota')
            }
          });
          sessionStorage.setItem('fleet_alerts_shown', '1');
        }
      } catch (e) {
        console.error('Falha ao carregar alertas de frota', e);
      }
    };
    checkAlerts();
  }, [navigate]);

  const toggleCollapsed = (v) => {
    setCollapsed(v);
    localStorage.setItem('sb_collapsed', v ? '1' : '0');
  };

  return (
    <div className="min-h-screen bg-neutral-50 dark:bg-neutral-950 text-neutral-900 dark:text-neutral-100">
      <Sidebar collapsed={collapsed} setCollapsed={toggleCollapsed} />
      <div className={`transition-all duration-200 ${collapsed ? 'ml-[72px]' : 'ml-64'}`}>
        <Header onOpenPalette={() => setCmdOpen(true)} />
        <main className="p-4 md:p-6">
          <Outlet />
        </main>
      </div>
      <CommandPalette open={cmdOpen} onClose={() => setCmdOpen(false)} />
      <Toaster richColors position="top-right" />
    </div>
  );
}
